export default "__VITE_ASSET__D2tc826y__"